// extracted by mini-css-extract-plugin
export default {"contentToggle":"ContentToggle_contentToggle__xQIiW","linkStyle":"ContentToggle_linkStyle__IDKkt"};